import { produce } from "immer";
import {
  FETCH_VACCINATION,
  FETCH_VACCINATION_SUCCESS,
  FETCH_VACCINATION_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_VACCINATION,
  ADD_VACCINATION_SUCCESS,
  ADD_VACCINATION_FAILURE,
  //
  EDIT_VACCINATION,
  EDIT_VACCINATION_SUCCESS,
  EDIT_VACCINATION_FAILURE,
  //
  DELETE_VACCINATION,
  DELETE_VACCINATION_SUCCESS,
  DELETE_VACCINATION_FAILURE,
  //
  TOGGLE_VACCINATION_MODAL,
} from "./constants";

export const initialState = {
  isFetchingVaccination: false,
  vaccination: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentVaccination: {},
  // Delete
  isDeleting: false,
  vaccinationModal: { open: false, isEditing: false, currentVaccination: null },
};

const ResidentVaccinationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_VACCINATION:
        draft.isFetchingVaccination = true;
        draft.vaccination = {};
        break;
      case FETCH_VACCINATION_SUCCESS:
        draft.isFetchingVaccination = false;
        draft.vaccination = action.payload;
        break;
      case FETCH_VACCINATION_FAILURE:
        draft.vaccination = {};
        draft.isFetchingVaccination = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentVaccination = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentVaccination = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_VACCINATION:
        draft.isSubmitting = true;
        break;
      case ADD_VACCINATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_VACCINATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_VACCINATION:
        draft.isSubmitting = true;
        break;
      case EDIT_VACCINATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_VACCINATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_VACCINATION:
        draft.isDeleting = true;
        break;
      case DELETE_VACCINATION_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_VACCINATION_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_VACCINATION_MODAL:
        draft.vaccinationModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default ResidentVaccinationReducer;
